import './about.css';
import { createPortal } from 'react-dom';
import { useEffect,useState } from 'react';

const images = [
  '/about/community/screenshot-1.png',
  '/about/community/screenshot-2.png',
  '/about/community/screenshot-3.png',
];

const AboutCommunity = () => {
  const [activeImage, setActiveImage] = useState(null);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setActiveImage(null);
      }
    };

    window.addEventListener('keydown', handleEscape);

    return () => {
      window.removeEventListener('keydown', handleEscape);
    };
  }, []);

  const overlay = activeImage && createPortal(
    <div
      className='about-gallery-overlay'
      onClick={() => setActiveImage(null)}
    >
      <img
        className='about-gallery-expanded'
        src={activeImage}
        alt='Expanded Phi Corp Gallery'
        onClick={(e) => e.stopPropagation()}
      />
    </div>,
    document.body
  );

  return (
    <>
      <div className='about-gallery'>
        {images.map((image) => (
          <img
            key={image}
            className='about-gallery-image'
            src={image}
            alt='Phi Corp Gallery'
            onClick={() => setActiveImage(image)}
          />
        ))}
      </div>

      {overlay}
    </>
  );
};

export default AboutCommunity;